import {
  FETCH_DATA3D_REQUEST,
  FETCH_DATA3D_SUCCESS,
  FETCH_DATA3D_FAILURE,
  SELECT_ENTITY,
  DELETE_ENTITY,
  DXF_INITIATE,
  DXF_MODE,
  WITH_BG_PARTITIONS,
  WITH_BG_DOORS,
  WITH_BG_BACKGROUND_COLOR
} from "../constants/withBgConstants";

const initialState = {
  Data3D: [],
  selectedId: null, // Renamed to selectedUuid for clarity, but kept as selectedId to match your convention
  loader: false,
  error: null,
  delete: false,
  dxf: '',
  dxf_intitate: false,
  partitions: [],
  doors: [],
  background_color : '#212830'
};

const withBgReducers = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DATA3D_REQUEST:
      return { ...state, loader: true, error: null };
    case FETCH_DATA3D_SUCCESS:
      return { ...state, loader: false, Data3D: action.payload, selectedId: state.selectedId };
    case FETCH_DATA3D_FAILURE:
      return { ...state, loader: false, error: action.payload };
    case SELECT_ENTITY:
      return { ...state, selectedId: action.payload };
    case DELETE_ENTITY:
      return { ...state, delete: action.payload };
    case DXF_MODE:
      return { ...state, dxf: action.payload };
    case DXF_INITIATE:
      return { ...state, dxf_intitate: action.payload };
    case WITH_BG_PARTITIONS:
      return { ...state, partitions: action.payload };
    case WITH_BG_DOORS:
      return { ...state, doors: action.payload };
    case WITH_BG_BACKGROUND_COLOR:
      return { ...state, background_color: action.payload };

    default:
      return state;
  }
};

export default withBgReducers;